import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TraceabilitySearch from './components/traceability-search/traceability-search';
import TraceabilityResult from './components/traceability-result/traceability-result';
import Layout from './layouts/Layout';
import './App.scss';
import './i18n';

function App() {
  return (
    <Suspense fallback="Loading...">
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Layout><TraceabilitySearch /></Layout>} />
            <Route path="/traceability-result/*" element={<Layout><TraceabilityResult /></Layout>} />
            <Route path="/traceability/*" element={<Layout><TraceabilityResult /></Layout>} />
          </Routes>
        </div>
      </Router>
    </Suspense>
  );
}

export default App;
